module.exports = __webpack_public_path__ + "static/img/icn_calendar_3d.b1803ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/icn_calendar_3d.png
// module id = vP0/
// module chunks = 1